package com.ijoin.platform

import androidx.compose.runtime.Composable

/**
 * Platform-specific voice recorder for audio transcription.
 * Records audio and provides the recorded data as ByteArray.
 */
@Composable
expect fun rememberVoiceRecorder(): VoiceRecorderState

/**
 * State of the voice recorder.
 */
data class VoiceRecorderState(
    /** Start recording audio */
    val startRecording: () -> Unit,
    /** Stop recording and get result */
    val stopRecording: () -> Unit,
    /** Whether recording is currently in progress */
    val isRecording: Boolean,
    /** Recorded audio data as ByteArray (available after stopRecording) */
    val recordedData: ByteArray?,
    /** Recording duration in seconds */
    val durationSeconds: Int,
    /** Error message if recording failed */
    val error: String?,
    /** Clear the recorded data and error */
    val clear: () -> Unit,
    /** Audio format extension (e.g., "m4a", "webm") */
    val audioFormat: String = "m4a"
) {
    companion object {
        const val MIN_DURATION_SECONDS = 3
        const val MAX_DURATION_SECONDS = 300 // 5 minutes
    }
}
